module.exports = __webpack_public_path__ + "img/pics_fast-easy-listing.46a4b771.svg";